/* tslint:disable */
/* eslint-disable */
/**
 * Y-sports-Core API
 * API for managing Y-sports related stuff
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum TeamStatus {
    Registered = 'REGISTERED',
    Validated = 'VALIDATED',
    PendingPayment = 'PENDING_PAYMENT',
    Accepted = 'ACCEPTED',
    Rejected = 'REJECTED'
}


export function TeamStatusFromJSON(json: any): TeamStatus {
    return TeamStatusFromJSONTyped(json, false);
}

export function TeamStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): TeamStatus {
    return json as TeamStatus;
}

export function TeamStatusToJSON(value?: TeamStatus | null): any {
    return value as any;
}

